var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 5.66406V3.47656C18.7109 2.83039 18.1852 2.30469 17.5391 2.30469H13.7109C13.0648 2.30469 12.5391 2.83039 12.5391 3.47656V5.66406H18.7109Z",
    fill: "#773DD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 6.83594H18.7109V7.92969H12.5391V6.83594Z",
    fill: "#773DD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28906 11.4453V19.4141C1.28906 19.7377 1.55141 20 1.875 20C2.19859 20 2.46094 19.7377 2.46094 19.4141V14.0314L10.0391 14.0546V18.4375C10.0391 18.7611 10.3014 19.0234 10.625 19.0234H10.9766V19.4141C10.9766 19.7377 11.2389 20 11.5625 20C11.8861 20 12.1484 19.7377 12.1484 19.4141V19.0234H16.6016V19.4141C16.6016 19.7377 16.8639 20 17.1875 20C17.5111 20 17.7734 19.7377 17.7734 19.4141V19.0234H18.125C18.4486 19.0234 18.7109 18.7611 18.7109 18.4375V11.4453H1.28906Z",
    fill: "#773DD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 9.10156H8.95984C8.8548 8.59461 8.61934 8.04594 8.25473 7.46094H10.0391C10.6852 7.46094 11.2109 6.93523 11.2109 6.28906V1.17188C11.2109 0.525703 10.6852 0 10.0391 0H2.46094C1.81477 0 1.28906 0.525703 1.28906 1.17188V6.28906C1.28906 6.93523 1.81477 7.46094 2.46094 7.46094H4.24527C3.8807 8.04594 3.6452 8.59461 3.54016 9.10156H0.585938C0.262344 9.10156 0 9.36391 0 9.6875C0 10.0111 0.262344 10.2734 0.585938 10.2734H19.4141C19.7377 10.2734 20 10.0111 20 9.6875C20 9.36391 19.7377 9.10156 19.4141 9.10156Z",
    fill: "#773DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking);
export default __webpack_public_path__ + "static/media/working.14f2fb71a374f47cdd91cd8201cc0d6c.svg";
export { ForwardRef as ReactComponent };